module.exports = __webpack_public_path__ + "media/images/collapseArrows-490d887a.png";